if (!customElements.get('lifestyle-media-filter')) {
  class LifestyleMediaFilter extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
      
      // Update layout positioning
      this.updateLayout();
      this.updateLineOutView();

      // Listen for variant change
      document.addEventListener('variant:change', (event) => {
        if (event.detail.variant && event.detail.variant.title) {
          this.updateMedia(event.detail.variant.title);
        }
      });

      // Handle resize for layout updates
      window.addEventListener('resize', () => {
        this.updateLayout();
        this.updateLineOutView();
      });

      // Trigger initial load update
      const initialVariantTitle = this.getAttribute('initial-variant');
      if (initialVariantTitle) {
        this.updateMedia(initialVariantTitle);
      }
    }

    init() {
      this.lifestyleItems = this.querySelectorAll('.js-lifestyle-item');
      this.closeupItems = this.querySelectorAll('.js-closeup-item');
      this.closeupItemsMobile = this.querySelectorAll('.js-closeup-item-mobile');
      this.carousel = this.querySelector('scroll-carousel');
      this.wrapper = this.querySelector('.js-product-projects__wrapper');
      this.carouselWrapper = this.querySelector('.js-carousel-wrapper');
      this.rightMedia = this.querySelector('.js-right-media');
      this.dotsContainer = this.querySelector('.js-dots-container');
      this.navContainer = this.querySelector('.js-carousel-nav');
    }

    updateMedia(variantTitle) {
      const primaryOption = variantTitle.split(' / ')[0];

      const normalized = primaryOption.toLowerCase()
        .trim()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '');

      // Update Lifestyle Items
      let visibleCount = 0;
      const toHideIndexes = [];

      this.lifestyleItems.forEach((item, index) => {
        const filename = (item.dataset.filename || '').toLowerCase();
        if (filename.includes(normalized) || filename.startsWith('metafield-')) {
          item.classList.remove('hide');
          item.removeAttribute('hidden');
          visibleCount++;
        } else {
          item.classList.add('hide');
          toHideIndexes.push(index);
        }
      });

      // Filter Scroll Carousel
      if (this.carousel) {
        // If the carousel has the filter method, use it; otherwise, it might be hiding items via class anyway
        if (typeof this.carousel.filter === 'function') {
          this.carousel.filter(toHideIndexes);
          setTimeout(() => {
            if (typeof this.carousel.select === 'function') {
              this.carousel.select(0, { instant: true });
            }
          }, 50);
        }
      }


      // Target ALL navigation elements (including main nav container and any floating arrows)
      const allNavs = this.querySelectorAll('.js-carousel-nav, .prev-next-button');
      
      if (visibleCount <= 1) {
        allNavs.forEach(nav => nav.classList.add('hide'));
      } else {
        allNavs.forEach(nav => nav.classList.remove('hide'));
      }

      // Filter Close-up Items
      const updateSideMedia = (items) => {
        let found = false;
        items.forEach(item => {
          const filename = (item.dataset.filename || '').toLowerCase();
          if (filename.includes('close-up') && filename.includes(normalized)) {
            item.classList.remove('hidden');
            item.removeAttribute('hidden');
            found = true;
          } else {
            item.classList.add('hidden');
            item.setAttribute('hidden', '');
          }
        });

        if (!found) {
          const firstPotential = Array.from(items).find(item => {
            const fname = (item.dataset.filename || '').toLowerCase();
            return (fname.includes('close-up') && fname.includes(normalized)) || fname.startsWith('metafield-');
          });
          if (firstPotential) {
            firstPotential.classList.remove('hidden');
            firstPotential.removeAttribute('hidden');
            return true;
          }
        }
        return found;
      };

      const sideMediaMet = updateSideMedia(this.closeupItems);
      const sideMediaMobileMet = updateSideMedia(this.closeupItemsMobile);

      const hasLifestyleImages = this.lifestyleItems.length > 0;
      const hasMatchingLifestyle = visibleCount > 0;
      const hasMatchingCloseup = sideMediaMet || sideMediaMobileMet;

      // Instead of hiding the section, toggle the "no-images" layout
      const shouldShowNoImageLayout = (hasLifestyleImages && !hasMatchingLifestyle) || (!hasLifestyleImages && !hasMatchingCloseup);

      if (this.wrapper) {
        if (shouldShowNoImageLayout) {
          this.wrapper.classList.add('product-projects__wrapper--no-images');
          if (this.carouselWrapper) this.carouselWrapper.classList.add('hide');
          if (this.rightMedia) this.rightMedia.classList.add('hide');
        } else {
          this.wrapper.classList.remove('product-projects__wrapper--no-images');
          if (this.carouselWrapper) this.carouselWrapper.classList.remove('hide');
          if (this.rightMedia) this.rightMedia.classList.remove('hide');
        }
      }

      // Ensure the component itself is always visible now
      this.classList.remove('hide');

      // Re-run the positioning update
      setTimeout(() => this.updateLayout(), 100);
    }

    updateLayout() {
      const carouselWrapper = this.querySelector('.js-carousel-wrapper');
      const rightMedia = this.querySelector('.js-right-media');
      const onlyMediaContainer = this.querySelector('.js-only-media-available');

      if (!carouselWrapper || !rightMedia) return;

      if (window.innerWidth <= 999) {
        const overlapHeight = carouselWrapper.offsetHeight * 0.4;
        rightMedia.style.transform = `translateY(-${overlapHeight}px)`;
        rightMedia.style.marginBottom = `-${overlapHeight}px`;

        if (onlyMediaContainer) {
          onlyMediaContainer.style.paddingBottom = `${overlapHeight}px`;
        }
      } else {
        rightMedia.style.transform = '';
        rightMedia.style.marginBottom = '';

        if (onlyMediaContainer) {
          onlyMediaContainer.style.paddingBottom = '';
        }
      }
    }

    updateLineOutView() {
      this.querySelectorAll('.line_out_view').forEach(el => {
        const width = el.offsetWidth + 12;
        el.style.setProperty('--after-right', `${width}px`);
      });
    }
  }

  customElements.define('lifestyle-media-filter', LifestyleMediaFilter);
}
